const socialList = [
  {
    name: 'Google', value: 'google', icon: '/img/icons/social/google.svg', enabled: true,
  },
  {
    name: 'Steam', value: 'steam', icon: '/img/icons/social/steam.svg', enabled: false,
  },
  {
    name: 'Discord', value: 'discord', icon: '/img/icons/social/discord.svg', enabled: true,
  },
  {
    name: 'Blizzard', value: 'blizzard', icon: '/img/icons/social/blizzard.svg', enabled: false,
  },
  {
    name: 'Apple ID', value: 'appleid', icon: '/img/icons/social/appleid.svg', enabled: false,
  },
  {
    name: 'Facebook', value: 'fb', icon: '/img/icons/social/facebook.svg', enabled: true,
  },
];

const goalList = [
  { value: '1', label: 'Complete Events', text: 'I want to complete event tasks' },
  { value: '2', label: 'Fun', text: 'I want fun matches, the victory is not so important' },
  { value: '3', label: 'Wins', text: 'Nothing matters, victory is all I wish!' },
  { value: '4', label: 'Explore the game', text: 'I want to learn tactics and new things' },
  { value: '5', label: 'Killrace', text: 'Get as many kills as possible' },
  { value: '6', label: 'Challenges', text: 'I want to complete a challenge in the game' },
];

const platformList = [
  {
    id: '1', title: 'PC', icon: 'icon icon-pc', label: 'Your BLIZZARD ID',
  },
  {
    id: '2', title: 'XBOX', icon: 'icon icon-xbox', label: 'Your XBOX LIVE ID',
  },
  {
    id: '3', title: 'PLAYSTATION', icon: 'icon icon-playstation', label: 'Your PSN ID',
  },
  {
    id: '4', title: 'ACTIVISION', icon: 'icon icon-acti', label: 'Your ACTIVISION ID',
  },
];

const orderStatuses = {
  ORDER_NEW: '0',
  ORDER_ACTIVE: '1',
  ORDER_FINISHED: '2',
};

export {
  // eslint-disable-next-line import/prefer-default-export
  socialList,
  goalList,
  orderStatuses,
  platformList,
};
